import { render, staticRenderFns } from "./Orcamentos.vue?vue&type=template&id=a2c0525e&scoped=true"
import script from "./Orcamentos.vue?vue&type=script&lang=js"
export * from "./Orcamentos.vue?vue&type=script&lang=js"
import style0 from "./Orcamentos.vue?vue&type=style&index=0&id=a2c0525e&prod&scoped=true&lang=css"
import style1 from "./Orcamentos.vue?vue&type=style&index=1&id=a2c0525e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c0525e",
  null
  
)

export default component.exports